import { render, staticRenderFns } from "./DirectoryCard.vue?vue&type=template&id=5533e896&scoped=true&"
import script from "./DirectoryCard.vue?vue&type=script&lang=js&"
export * from "./DirectoryCard.vue?vue&type=script&lang=js&"
import style0 from "./DirectoryCard.vue?vue&type=style&index=0&id=5533e896&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5533e896",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {RatingStars: require('/home/circleci/repo/components/RatingStars.vue').default})
